import { Component, Prop, Vue } from 'vue-property-decorator';
import { ActionMenuItem } from '@/models';

@Component
export default class ActionMenu extends Vue {
  @Prop({ default: [] }) items: ActionMenuItem[];
  
  onItemClicked(item: ActionMenuItem): void {
    if (!item.disabled) {
      item.handler();
    }
  }
}
